export const environment = {
  production: true,
  buildId: '2842899680019461',
  configFile: 'config.json',
};
